import React from 'react'
import { InputBase, InputBaseProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export type InputVariant = 'filled' | 'underline'

export interface InputProps extends InputBaseProps {
  /** `filled` = boxed field; `underline` = large display name input */
  variant?: InputVariant
}

const Filled = styled(InputBase)({
  width: '100%',
  fontFamily: 'var(--ds-font)',
  fontSize: 16,
  color: 'var(--ds-ink)',
  backgroundColor: 'var(--ds-hover)',
  borderRadius: 'var(--ds-radius-md)',
  padding: '12px 16px',
  transition: `box-shadow var(--ds-duration-fast) var(--ds-ease)`,
  '& input::placeholder': {
    color: 'var(--ds-ink-subtle)',
    opacity: 1,
  },
  '&.Mui-focused': {
    boxShadow: `0 0 0 2px var(--ds-ink)`,
  },
})

const Underline = styled(InputBase)({
  width: '100%',
  fontFamily: 'var(--ds-font)',
  fontSize: 26,
  fontWeight: 700,
  letterSpacing: '-0.03em',
  color: 'var(--ds-ink)',
  background: 'transparent',
  padding: '0 0 10px',
  borderBottom: '2px solid var(--ds-border)',
  borderRadius: 0,
  transition: 'border-color var(--ds-duration-normal) var(--ds-ease)',
  '& input::placeholder': {
    color: 'var(--ds-border-strong)',
    opacity: 1,
    fontWeight: 700,
  },
  '&.Mui-focused': {
    borderBottomColor: 'transparent',
    borderImage: 'var(--ds-gradient-spectrum, var(--ds-ink)) 1',
    borderBottom: '2px solid',
  },
})

export const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  { variant = 'filled', ...props },
  ref,
) {
  const Root = variant === 'underline' ? Underline : Filled
  return <Root inputRef={ref} {...props} />
})
